import portfolioImage from '../assets/example.png';
import foodstuffsStore from '../assets/foodstuffs_store.png';

interface ProjectsType {
    title: string
    description: string
    image: string
    GitHub: string
    hosted: string
  }
  
  export const ProjectsData: ProjectsType[] = [
    {
      title: 'React Todo List',
      description: `A simple to-do list app powered by React, Chakra UI, React icons. Save in Local Storage!`,
      image: 'https://raw.githubusercontent.com/md0011/todo-list/main/readme/example.png',
      GitHub: 'https://github.com/md0011/todo-list',
      hosted: 'https://todo-list-mayurdev.vercel.app/',
    },
    {
      title: 'Foodstuffs Store',
      description: `A single-page store website, built with: React,react-router-dom and React Icon`,
      image: `${foodstuffsStore}`,
      GitHub: '',
      hosted: 'https://foodstuffs-store.vercel.app/',
    },
    {
      title: 'User Registration',
      description: `A simple user registration and admin dashboard application built with MERN stack.`,
      image: 'https://raw.githubusercontent.com/md0011/user-registration/main/client/src/images/example.png',
      GitHub: 'https://github.com/md0011/user-registration',
      hosted: 'https://user-registration-test.vercel.app/',
    },
    {
      title: 'Animated Portfolio',
      description: `Portfolio website built with React, Typescript, react-router-dom, framer-motion, react-icons, Scss`,
      image: `${portfolioImage}`,
      GitHub: '',
      hosted: 'https://mayurdev.vercel.app/',
    },
    {
      title: 'Password Generator',
      description: `A user-friendly interface for generating secure and customizable random passwords.`,
      image: 'https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      GitHub: 'https://github.com/md0011/password-generator',
      hosted: `https://strong-random-password-generator.vercel.app/`,
    },
    {
      title: 'UI/UX Portfolio',
      description: `A personal portfolio website built using HTML, CSS, and JavaScript to showcase UI/UX design skills and projects.`,
      image: 'https://raw.githubusercontent.com/md0011/UI-UX-Portfolio/refs/heads/main/images/thumbnail.png?token=GHSAT0AAAAAAC7YQU54NKANBQZJZ6IAS2VG2AHSTDQ',
      GitHub: 'https://github.com/md0011/UI-UX-Portfolio',
      hosted: 'https://mayurdev.netlify.app/',
    },
    {
      title: 'MCQ Quiz App',
      description: `A simple MCQ application built using HTML, CSS, and JavaScript. Users can answer a series of questions and see their final score.`,
      image: 'https://images.unsplash.com/photo-1606326608606-aa0b62935f2b?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      GitHub: 'https://github.com/md0011/MCQ_Quiz_App',
      hosted: `https://mcq-quiz-test.vercel.app/`,
    },
    {
      title: 'Random Quote Generator',
      description: `A Random Quote Generator is capable of pulling quotes randomly from an API.`,
      image: 'https://raw.githubusercontent.com/md0011/RandomQuoteGenerator/master/Screenshot.png',
      GitHub: 'https://github.com/md0011/RandomQuoteGenerator',
      hosted: 'https://md0011.github.io/RandomQuoteGenerator/',
    }
  ];
